import {
  VpCheckbox,
  VpFormControl,
  VpFormLabel,
} from '@vtmn-play/react/headless';
import { FormEvent, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { SpoGendersResponseItem } from '@spo/types';
import './gender-checkbox.scss';

export interface GenderCheckboxesProps {
  chosenGenderIds: number[];
  allGenders: SpoGendersResponseItem[];
  selectedGenderIds: number[];
  setSelectedGenderIds: React.Dispatch<React.SetStateAction<number[]>>;
  disabled: boolean;
}

export const GenderCheckboxes = ({
  chosenGenderIds,
  allGenders,
  selectedGenderIds,
  setSelectedGenderIds,
  disabled,
}: GenderCheckboxesProps) => {
  const { t } = useTranslation();

  useEffect(() => {
    chosenGenderIds.length > 0 && setSelectedGenderIds(chosenGenderIds);
  }, [chosenGenderIds, setSelectedGenderIds]);

  const handleDefaultChecked = (genderId: number) =>
    chosenGenderIds.includes(genderId);

  const checkGender = (
    event: FormEvent<HTMLInputElement>,
    checkedGender: SpoGendersResponseItem,
  ) => {
    if (event.currentTarget.checked) {
      setSelectedGenderIds([...selectedGenderIds, checkedGender.id]);
    } else {
      setSelectedGenderIds(
        selectedGenderIds.filter((genderId) => genderId !== checkedGender.id),
      );
    }
  };

  return (
    <VpFormControl className="genders-checkboxes-container">
      <VpFormLabel>{t('input.genders_label')}</VpFormLabel>
      <div data-testid="genders-checkboxes" className="genders-checkboxes">
        {disabled ? (
          <div>
            {allGenders
              .filter((gender) => chosenGenderIds.includes(gender.id))
              .map((gender) => t(`gender.${gender.label}`))
              .join(', ')}
          </div>
        ) : (
          allGenders.map((gender) => (
            <VpCheckbox
              key={gender.id}
              value={gender.label}
              data-testid={`gender-${gender.label?.toLowerCase()}`}
              defaultChecked={handleDefaultChecked(gender.id)}
              onChange={(event) => event && checkGender(event, gender)}
            >
              {t(`gender.${gender.label}`)}
            </VpCheckbox>
          ))
        )}
      </div>
    </VpFormControl>
  );
};
